import {
    ApiBaseService,
    type ApiServiceConfig,
} from "~/services/ApiBaseService";
import type { ApiResponse } from "~/types/ApiResponse";
import type { FieldDefinition } from "~/models/Automation";

export default class VincereService extends ApiBaseService {
    protected uuid: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config);

        this.uuid = uuid;
    }

    public getObjectWithRelations(object: string): Promise<
        ApiResponse<
            {
                label: string;
                value: string;
            }[]
        >
    > {
        return this.request(
            this.route(
                "api.connections.vincere.object-with-relations",
                "/connections/vincere/{connection}/object-with-relations/{object}",
                {
                    connection: this.uuid,
                    object,
                },
            ),
            {
                method: "GET",
            },
        );
    }

    public describe(
        object: string,
        options?: Partial<{
            updatable: boolean;
        }>,
    ): Promise<ApiResponse<FieldDefinition[]>> {
        return this.request(
            this.route(
                "api.connections.vincere.describe",
                "/connections/vincere/{connection}/{object}",
                {
                    connection: this.uuid,
                    object,
                },
            ),
            {
                method: "GET",
                query: options,
            },
        );
    }
}
